import { h } from 'preact';

import Skeleton from '@mui/material/Skeleton';
import InputLabel from '@mui/material/InputLabel';

export default function LazyDateSelect(_props) {
  return (
    <InputLabel>
      Date of analysis: <Skeleton height={32} width={82} />
    </InputLabel>
  );
}
